"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configure = void 0;
const tslib_1 = require("tslib");
const Presets_1 = require("./Presets");
const getUrlGenerator_1 = tslib_1.__importDefault(require("./Utils/getUrlGenerator"));
let target = {
    ...Presets_1.Presets[(0, Presets_1.presetFromUrl)(window.location.host)],
    toApiUrl: (0, getUrlGenerator_1.default)(Presets_1.Presets[(0, Presets_1.presetFromUrl)(window.location.host)].apiUrl),
    toSpaUrl: (0, getUrlGenerator_1.default)(Presets_1.Presets[(0, Presets_1.presetFromUrl)(window.location.host)].spaUrl),
    toStaticUrl: (0, getUrlGenerator_1.default)(Presets_1.Presets[(0, Presets_1.presetFromUrl)(window.location.host)].staticUrl),
    toStrutsUrl: (0, getUrlGenerator_1.default)(Presets_1.Presets[(0, Presets_1.presetFromUrl)(window.location.host)].strutsUrl),
};
let isConfigured = false;
let renderFunction = null;
/**
 * @internal
 *
 * @deprecated
 * configure is deprecated. Fetch target values directly instead
 *
 * @example
 * ```typescript
 *   // TargetConsumer is not needed anymore. Get the values directly instead by
 *   import { getApiUrl, getTargetMeta } from "@mne-core/providers/Target";
 *   const apiUrl = getApiUrl();
 *   const { apiUrl, baseUrl, metaInfo, domain, env, ...} = getTargetMeta();
 *
 * ```
 */
const configure = (opts) => {
    const { onError } = opts || {};
    const isNotConfiguredException = new Error("isNotConfiguredException");
    if (onError) {
        isConfigured = true;
    }
    return {
        getTarget: () => {
            if (!isConfigured)
                throw isNotConfiguredException;
            return target;
        },
        requestTarget: (renderFn) => {
            if (!isConfigured)
                throw isNotConfiguredException;
            if (renderFunction === null || renderFunction !== renderFn) {
                renderFunction = renderFn;
            }
            renderFunction(target);
        },
        rerender: () => {
            if (!isConfigured)
                throw isNotConfiguredException;
            if (renderFunction) {
                renderFunction(target);
            }
            else {
                const error = new Error("renderFn is empty");
                onError(error);
            }
        },
        setTarget: (newTarget) => {
            if (!isConfigured)
                throw isNotConfiguredException;
            target = newTarget;
        },
    };
};
exports.configure = configure;
